import FJTextToImageDataConfig, { MODELS_VALUE } from '../../config/dataConfig/FJTextToImageDataConfig';
import FJConfig from '../../config/FJConfig';
import FJConstant from '../../constants/FJConstant';
import FJTextToImageConstant from '../../constants/FJTextToImageConstant';
import FJCompressedImageStore from '../../store/FJCompressedImageStore';
import FJImageStore from '../../store/FJImageStore';
import FJLocalStore from '../../store/FJLocalStore';
import FJMessageStore from '../../store/FJMessageStore';
import FJNetworkStore from '../../store/FJNetworkStore';
import FJUtil from '../../util/FJUtil';
import {
    setSliceCurGeneratingPromptImageUrl,
    setSliceGenerateNumber,
    setSliceInspireList,
    setSliceIsShowPresetImageBox,
    setSliceModel,
    setSlicePresetImageList,
    setSlicePrompt,
    setSlicePromptStatus,
    setSliceStyle,
    setSliceStyleList,
    setSliceUploadImageInfo,
    setSliceUploadStatus,
    setSliceRatio,
    setSliceIsPrompt,
    setSliceUploadImages,
    setSliceResolution,
    setSlicePromptMaxLength,
    setSlicePrivacySettingAction,
    setSliceCreationListAction,
    setSliceTaskStatusAction,
    setSliceFreeNumCreationAction,
} from '../slices/FJSliceTextToImage';
import FJActionCommon from './FJActionCommon';
import FJActionModal from './FJActionModal';
// import FJActionGuide from './FJActionGuide.js';
import {
    MAX_COMPRESS_IMAGE_SIZE,
    UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE,
} from '../../config/dataConfig/FJGenerateData';
import FJS3Config from '../../config/FJS3Config.js';
import FJUserSelectionStore, { SELECTION_KEYS } from '../../store/FJUserSelectionStore';
import FJAppConstant from '../../constants/FJAppConstant';
import FJTextToImageConfig from '../../config/appConfig/FJTextToImageConfig.js';
import { AI_GENERATOR_VIDEO_TAB_TYPE } from '../../config/dataConfig/FJAIVideoGeneratorData.js';

let _text2imgEventIdList = [];
let _imageRecognitionStatus = false; // 图片识别状态  false 表示未识别  true 表示正在识别
let _aiOptimizingStatus = false; // AI优化状态  false 表示未优化  true 表示正在优化

// 支持多任务的模型, 只会调用一次，生成多张
const SUPPORT_MULTI_TASK_MODELS = [MODELS_VALUE.OPENAI_GPT_IMAGE_1, MODELS_VALUE.FLUX_DEV, MODELS_VALUE.FLUX_SCHNELL];

const _getTextToImageMaxImages = curModel => {
    return FJTextToImageDataConfig.MODELS.find(item => item.value === curModel)?.supportImageReferenceNum || 1;
};
const FJActionTextToImage = {
    updateUseFreeLimitAction: function (info) {
        return async dispatch => {
            dispatch(setSliceFreeNumCreationAction(info[FJTextToImageConfig.freeLimitType]));
        };
    },
    editHistoryItemAction: function (data = {}) {
        return async (dispatch, getState) => {
            const { textToImagePrompt, prompt, modelType, style, referenceImages } = data;

            dispatch(setSlicePrompt(textToImagePrompt || prompt));
            dispatch(this.changeGenerateNumberAction(1));

            dispatch(setSliceModel(modelType));
            const curModelData = FJTextToImageDataConfig.MODELS.find(item => item.value === modelType);
            if (curModelData) {
                if (curModelData.value === MODELS_VALUE.GOOGLE_NANO_BANANA_PRO) {
                    dispatch(setSliceRatio(curModelData?.supportRatios?.[5]));
                } else {
                    // 如果新模型支持当前比例则继承，否则默认选择第一个
                    dispatch(setSliceRatio(curModelData?.supportRatios?.[0]));
                }

                // 如果新模型支持当前分辨率则继承，否则默认选择第一个
                dispatch(setSliceResolution(curModelData?.supportResolutions?.[0]?.value || null));
            }

            if (style) {
                const styleList = getState().textToImage.styleList;
                let styleData = null;
                styleList.forEach(item => {
                    item.list.forEach(item => {
                        if (item.name === style) {
                            styleData = item;
                        }
                    });
                });

                styleData && dispatch(setSliceStyle(styleData));
            }

            if (referenceImages && referenceImages.length > 0) {
                try {
                    dispatch(setSliceUploadStatus(FJConstant.LOADING));
                    const imageInfos = await Promise.all(
                        referenceImages.map(async url => {
                            const image = await FJCompressedImageStore.compressImageByUrl(url);
                            return image;
                        }),
                    );
                    dispatch(setSliceUploadImages(imageInfos));
                } catch (error) {
                    console.error('error', error);
                } finally {
                    dispatch(setSliceUploadStatus(FJConstant.DEFAULT));
                }
            }
        };
    },

    setCreationListAction: function (list) {
        return dispatch => {
            dispatch(setSliceCreationListAction(list));
        };
    },
    setTaskStatusAction: function (value) {
        return dispatch => {
            dispatch(setSliceTaskStatusAction(value));
        };
    },
    setPrivacySettingAction: function (value) {
        return dispatch => {
            dispatch(setSlicePrivacySettingAction(value));
        };
    },
    resetAction: function () {
        return dispatch => {
            dispatch(setSliceIsShowPresetImageBox(true));
            // dispatch(setSliceGenerateNumber(2));
            dispatch(setSlicePrompt(''));
            // dispatch(setSliceStyle({ value: '', name: 'none', previewImg: 'none.jpg' }));
            // dispatch(setSliceModel('schnell'));
            // dispatch(setSliceRatio('1:1'));
            dispatch(setSliceUploadImages([]));
        };
    },
    changePromptAction: function (newPrompt) {
        return (dispatch, getState) => {
            const { prompt } = getState().textToImage;

            if (prompt === newPrompt) return;

            dispatch(setSlicePrompt(newPrompt));
        };
    },

    generateAction: function () {
        return async (dispatch, getState) => {
            const promptStatus = getState().textToImage.promptStatus;
            const inputImage = getState().textToImage.uploadImageInfo;
            const privacyStatus = getState().textToImage.privacyStatus;

            let uploadImages = getState().textToImage.uploadImages;
            if (promptStatus !== FJTextToImageConstant.NORMAL) {
                return;
            }

            const { prompt, curModel, curRatio, generateNumber, curStyle, curResolution } = getState().textToImage;
            const { creditNumber, freeNumCreation } = getState().common;
            const hasFreeCreation = freeNumCreation > 0;
            const curModelData = FJTextToImageDataConfig.MODELS.find(item => item.value === curModel);
            const curModelUseCredit =
                (curModelData?.creditPriceLevels && curModelData?.creditPriceLevels?.[curResolution]) ||
                curModelData?.useCredit;
            const curRatioData = FJTextToImageDataConfig.RATIO_LIST.find(item => item.name === curRatio);
            const curRatioValue = curRatioData?.value ?? 1;
            const supportMultiTask = SUPPORT_MULTI_TASK_MODELS.includes(curModel);

            let isFree = false;
            const size = {
                width: 512,
                height: 512 / curRatioValue,
            };

            FJUtil.eaLog('ai tools text to image generate click', {
                prompt,
                'prompt language': FJUtil.getStringLanguage(prompt),
                style: curStyle.name === 'none' ? '' : curStyle.name,
                mode: curModelData.name,
                ratio: curRatioValue,
                number: generateNumber,
                reference_image: !!inputImage?.src,
            });

            if (!FJUtil.isLogin() || FJUtil.isFreePayment()) {
                FJUtil.eaLog('AI Tools guide AB generate click 2025.4.14', {
                    tool: 'text to image',
                    AB: FJUtil.getAB(),
                });
            }

            const __errorCallback = (failTaskCount, errorCode) => {
                if (!failTaskCount) {
                    dispatch(setSliceCreationListAction([]));
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                } else {
                    const creationList = [...getState().textToImage.creationList];

                    const allTaskListLength = creationList.length;

                    for (let i = allTaskListLength - failTaskCount; i < allTaskListLength; i++) {
                        // 结构之后 creationList item 也是只读的
                        // TypeError: Cannot assign to read only property 'isLoading' of object '#<Object>'
                        creationList[i] = {
                            ...creationList[i],
                            isLoading: false,
                            isReload: true,
                            errorCode: errorCode,
                            model: curModel,
                        };
                    }

                    dispatch(setSliceCreationListAction(creationList));
                    dispatch(setSliceTaskStatusAction(FJConstant.ERROR));
                }
            };

            const __judgeCanGenerate = async () => {
                const _prompt = prompt.replace(/\s/g, '');
                if (_prompt.length === 0 || prompt.length === 0) {
                    FJMessageStore.addMessage(FJLocalStore._('please-enter-the-prompt'), 'error');
                    return false;
                }

                const userSpaceType = await FJUtil.checkUserSpace({
                    errorCallback: () => {
                        FJMessageStore.addMessage(
                            FJLocalStore._('failed-to-generate-the-image-please-try-it-again'),
                            'error',
                        );
                    },
                });
                if (userSpaceType > 0) {
                    dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                    return false;
                }

                const useCredit = curModelUseCredit * generateNumber;

                //4.额度判断
                const canFreeCreate = hasFreeCreation && generateNumber <= 2 && curModel === MODELS_VALUE.FLUX_SCHNELL;

                if (creditNumber < useCredit && !canFreeCreate) {
                    dispatch(FJActionModal.showUpgradeModalAction());
                    return false;
                }
                isFree = creditNumber < useCredit && canFreeCreate;
                return true;
            };

            const isCanGenerate = await __judgeCanGenerate();

            if (!isCanGenerate) {
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                return;
            }

            // 修改状态生成占位符
            const placeHolderList = FJUtil.createPlaceHolderListNew({
                count: generateNumber,
                width: size.width,
                height: size.height,
                type: FJConstant.CREATIONS,
                generateInfo: {
                    inputImage,
                    uploadImages,
                    prompt,
                    style: curStyle.name === 'none' ? '' : curStyle.name,
                    prompt_val: curStyle.value,
                    model_type: curModel,
                    ratio: curRatio,
                    generateNumber: supportMultiTask ? generateNumber : 1,
                    resolution: curResolution,
                },
            });
            dispatch(FJActionCommon.setHeaderTabIndexAction(FJConstant.CREATIONS));
            dispatch(setSliceTaskStatusAction(FJConstant.START));

            dispatch(setSliceIsShowPresetImageBox(false));
            dispatch(setSliceCreationListAction(placeHolderList));

            try {
                // 如果存在参考图且支持参考图的模型，上传s3
                let inputImageUrl = inputImage?.src ?? null;
                if (inputImageUrl && curModelData?.supportImageReference) {
                    const file = await FJUtil.getBlobByUrl(inputImageUrl);
                    const id = await FJUtil.hashEncode(inputImageUrl);
                    const key = FJConfig.originalImageKey + `${id}.png`;
                    const result = await FJImageStore.upLoadFileToS3Async(file, key);
                    if (result) {
                        inputImageUrl = FJS3Config.S3_SERVER_HOST + key;
                    } else {
                        __errorCallback();
                        return;
                    }
                }
                let inputImageUrls = [];
                if (
                    uploadImages &&
                    uploadImages.length > 0 &&
                    curModelData?.supportImageReference &&
                    curModelData?.supportImageReferenceNum > 1
                ) {
                    uploadImages = uploadImages.slice(0, curModelData?.supportImageReferenceNum);
                    const uploadPromises = uploadImages.map(async image => {
                        const file = await FJUtil.getBlobByUrl(image.src);
                        const id = await FJUtil.hashEncode(image.src);
                        const key = FJConfig.originalImageKey + `${id}.png`;
                        const result = await FJImageStore.upLoadFileToS3Async(file, key);
                        if (result) {
                            return FJS3Config.S3_SERVER_HOST + key;
                        }
                        return null;
                    });

                    const uploadResults = await Promise.all(uploadPromises);
                    inputImageUrls = uploadResults.filter(url => url !== null);

                    if (inputImageUrls.length === 0) {
                        __errorCallback();
                        return;
                    }
                }
                //文字翻译
                const trimPrompt = prompt.replace(/\s+/g, ' ');
                let usePrompt = trimPrompt;

                if (curModelData.needTranslate) {
                    usePrompt = await this._translatePrompt(usePrompt);
                }

                _text2imgEventIdList = [];

                const request = async () => {
                    const params = {
                        prompt: usePrompt + ` ${curStyle.value}`,
                        input_prompt: trimPrompt,
                        model_type: curModel,
                        ratio: curRatio,
                        style: curStyle.name === 'none' ? '' : curStyle.name,
                        prompt_val: curStyle.value,
                        generateNumber: supportMultiTask ? generateNumber : 1,
                        inputImage: inputImageUrl,
                        inputImages: inputImageUrls,
                        privacyStatus,
                    };
                    if (curModelData.supportResolutions) {
                        params.size = curResolution;
                    }
                    return await FJNetworkStore.textToImage(params);
                };
                // 是否支持多任务
                if (supportMultiTask) {
                    // 支持多任务，则生成一个任务
                    const eventId = await FJActionCommon.createRequestTask(request, dispatch);
                    eventId && _text2imgEventIdList.push(eventId);
                } else {
                    // 不支持多任务，则生成多个任务
                    for (let i = 0; i < generateNumber; i++) {
                        const eventId = await FJActionCommon.createRequestTask(request, dispatch);
                        eventId && _text2imgEventIdList.push(eventId);
                    }
                }
                if (!_text2imgEventIdList.length) {
                    __errorCallback();
                    return;
                }
                FJUtil.eaLog('ai generate community privacy settings', {
                    setting: privacyStatus,
                });
                FJUtil.updateAllCreditInfo();
                //7.轮询任务状态
                const callback = data => {
                    const { type, errorMessage, errorCode } = data;
                    if (type === FJConstant.ERROR) {
                        // 多任务时，失败任务数量为生成数量（整个任务会一起失败）, 单任务时，失败任务数量为失败任务数量
                        __errorCallback(supportMultiTask ? generateNumber : data.failTaskCount, errorCode);
                    }

                    // 将失败的任务更改为失败状态
                    if (type === FJConstant.SUCCESS && data.failTaskCount > 0) {
                        __errorCallback(data.failTaskCount, errorCode);
                    }

                    FJUtil.setLocalStorage();
                    if (type === FJConstant.SUCCESS) {
                        FJUtil.eaLog('ai tool generate success', {
                            tool: FJUtil.getToolName(),
                            'credit&free': isFree ? 'free' : 'credit',
                        });
                    }
                };
                const tool = FJUtil.getToolName();
                FJUtil.eaLog('ai tool start generating', { 'credit&free': isFree ? 'free' : 'credit', tool });
                dispatch(
                    FJActionCommon.pollingTaskAction(_text2imgEventIdList, {
                        callback,
                        progressNumber: generateNumber,
                        isUseFree: isFree,
                        appType: FJAppConstant.TEXT_TO_IMAGE,
                    }),
                );
            } catch (error) {
                __errorCallback();
            }
        };
    },
    /**


*/

    onClickUsePromptAction: function (presetData) {
        return async (dispatch, getState) => {
            const promptStatus = getState().textToImage.promptStatus;

            if (promptStatus !== FJTextToImageConstant.NORMAL) {
                return;
            }

            const { prompt, model_type, style, smallImageUrl } = presetData;
            const curModelData = FJTextToImageDataConfig.MODELS.find(item => item.value === model_type);
            // 模型选择 规则不一致 不统一
            if (model_type) {
                const { creditNumber } = getState().common;
                if (creditNumber === 0) {
                    dispatch(this.changeModelAction(MODELS_VALUE.FLUX_SCHNELL, false));
                } else {
                    const modelValue =
                        FJTextToImageDataConfig.V1_MODELS.find(item => item.name === model_type)?.v2Model || model_type;
                    modelValue && dispatch(this.changeModelAction(modelValue, false));
                }
            }

            if (smallImageUrl && curModelData?.supportImageReference) {
                dispatch(this.uploadImageUrlAction(smallImageUrl));
            }

            if (style) {
                const styleList = getState().textToImage.styleList;
                let styleData = null;
                styleList.forEach(item => {
                    item.list.forEach(item => {
                        if (item.name === style) {
                            styleData = item;
                        }
                    });
                });

                styleData && dispatch(setSliceStyle(styleData));
            }

            dispatch(this.changePromptAction(prompt));
        };
    },

    /**
     * 修改生成数量
     * @param {number} newGenerateNumber
     * @returns
     */
    changeGenerateNumberAction: function (newGenerateNumber) {
        return (dispatch, getState) => {
            const { generateNumber } = getState().textToImage;

            if (generateNumber === newGenerateNumber) return;

            const isLogin = FJUtil.isLogin();

            if (isLogin) {
                const { creditNumber, freeNumCreation } = getState().common;
                const curModel = getState().textToImage.curModel;
                const modelUseCredit = FJTextToImageDataConfig.MODELS.find(item => item.value === curModel)?.useCredit;

                if (
                    creditNumber < modelUseCredit * newGenerateNumber &&
                    (freeNumCreation === 0 || newGenerateNumber > 2)
                ) {
                    dispatch(FJActionModal.showUpgradeModalAction());
                    return;
                }
            }

            // 存储在本地 下次用户进入时使用
            localStorage.setItem('generateNumber', newGenerateNumber);
            dispatch(setSliceGenerateNumber(newGenerateNumber));
        };
    },

    /**
     * @desc 获取灵感
     * @returns
     */
    getInspireAction: function () {
        return async (dispatch, getState) => {
            const promptStatus = getState().textToImage.promptStatus;
            if (promptStatus !== FJTextToImageConstant.NORMAL) {
                return;
            }

            const inspireList = getState().textToImage.inspireList;

            if (!inspireList) {
                return;
            }

            const curLang = FJLocalStore.currentTag();
            const inspireListByLang = inspireList[curLang] || inspireList['en'];
            const curPrompt = getState().textToImage.prompt;

            const __getRandomInspire = () => {
                const randomIndex = Math.floor(Math.random() * inspireListByLang.length);

                if (inspireListByLang[randomIndex] === curPrompt) {
                    return __getRandomInspire();
                }
                return inspireListByLang[randomIndex];
            };

            let prompt = __getRandomInspire();

            dispatch(this.changePromptAction(prompt));
        };
    },

    initTextToImageDataAction: function () {
        return async dispatch => {
            const isFreePayment = FJUtil.isFreePayment();
            const isLogin = FJUtil.isLogin();
            const cachedModel = FJUserSelectionStore.load(
                FJAppConstant.TEXT_TO_IMAGE,
                SELECTION_KEYS.CUR_MODEL,
                MODELS_VALUE.BYTEDANCE_SEEDREAM_4_5,
                FJTextToImageDataConfig.MODELS,
            );

            if (cachedModel) {
                dispatch(this.changeModelAction(cachedModel, true));
            } else if (!isLogin || isFreePayment) {
                dispatch(this.changeModelAction(MODELS_VALUE.BYTEDANCE_SEEDREAM_4_5, false));
            }

            await dispatch(this.initTextToImageStaticDataAction());
        };
    },

    /**
     * @desc 文生图带参数访问加载
     * @returns
     */
    _loadTextToImageParamsAction: function () {
        return async dispatch => {
            if (window.isEditPage) {
                return;
            }
            const recId = FJUtil.getQueryString(FJConstant.REC_ID);
            const recIdInfo = recId ? JSON.parse(window.localStorage.getItem(recId)) : null;
            const query_model_type = FJUtil.getQueryString('model');

            if (query_model_type && Object.values(MODELS_VALUE).includes(query_model_type)) {
                dispatch(this.changeModelAction(query_model_type, true));
            }

            if (recIdInfo) {
                window.localStorage.removeItem(recId);
                dispatch(this.handleRecInfoAction(recIdInfo));
            } else {
                // dispatch(FJActionGuide.showTextToImageGuideModal());
            }
        };
    },
    handleRecInfoAction: function (recIdInfo) {
        return async (dispatch, getState) => {
            const { style, prompt, model_type, model, images, fromType } = recIdInfo;

            if (fromType === FJConstant.COMMUNITY) {
                dispatch(FJActionCommon.onRecreateAction(recIdInfo));
                return;
            }

            if (model_type || model) {
                let modelValue = FJTextToImageDataConfig.MODELS.find(
                    item => item.value === model_type || item.value === model,
                )?.value;
                if (!modelValue) {
                    modelValue = FJTextToImageDataConfig.V1_MODELS.find(
                        item => item.value === model_type || item.value === model,
                    )?.v2Model;
                }
                modelValue && dispatch(this.changeModelAction(modelValue, false));
            } else {
                dispatch(this.changeModelAction(MODELS_VALUE.FLUX_SCHNELL, false));
            }
            const styleList = getState().textToImage.styleList;

            if (images && images.length > 0) {
                try {
                    dispatch(setSliceUploadStatus(FJConstant.LOADING));
                    const imageInfos = await Promise.all(
                        images.map(async url => {
                            const image = await FJCompressedImageStore.compressImageByUrl(url);
                            return image;
                        }),
                    );
                    dispatch(setSliceUploadImages(imageInfos));
                } catch (error) {
                    console.error('error', error);
                } finally {
                    dispatch(setSliceUploadStatus(FJConstant.DEFAULT));
                }
            }

            let styleData = null;
            styleList.forEach(item => {
                item.list.forEach(item => {
                    if (item.name === style) {
                        styleData = item;
                    }
                });
            });

            styleData && dispatch(setSliceStyle(styleData));
            dispatch(this.changePromptAction(prompt));
        };
    },

    /**
     * @desc 初始化文生图静态数据
     * @returns
     */
    initTextToImageStaticDataAction: function () {
        return async dispatch => {
            await dispatch(this._initStylesAction());
            await dispatch(this._initInspireListAction());
            await dispatch(this._initPresetImageListAction());
        };
    },

    _translatePrompt: async function (prompt) {
        const isEnglish = FJUtil.isEnglish(prompt);

        if (isEnglish) {
            return prompt;
        }
        const postData = [{ text: prompt }];
        const result = await FJNetworkStore.translateValueToLanguage(postData);
        const usePrompt = result[0].translations[0].text;

        return usePrompt;
    },

    /**
     * 初始化灵感列表
     * @returns
     */
    _initInspireListAction: function () {
        return async dispatch => {
            const response = await fetch(FJTextToImageConfig.inspireListJsonPath);
            const inspireList = await response.json();
            dispatch(setSliceInspireList(inspireList));
        };
    },

    /**
     * 初始化文生图风格列表
     * @returns
     */
    _initStylesAction: function () {
        return async dispatch => {
            const response = await fetch(FJTextToImageConfig.stylesJsonPath);
            const resultData = await response.json();

            const stylesData = resultData.map(item => {
                return {
                    categoryName: item.categoryName,
                    list: item.list.map(item => ({
                        value: item.value,
                        name: item.name,
                        previewImg: `${FJTextToImageConfig.stylePreviewPath}${item.previewImg}`,
                    })),
                };
            });

            dispatch(setSliceStyle(stylesData[0].list[0]));
            dispatch(setSliceStyleList(stylesData));
        };
    },

    _initPresetImageListAction: function () {
        return async dispatch => {
            const response = await fetch(FJTextToImageConfig.presetImageListJsonPath);
            const allPresetImageList = await response.json();

            const getRandomIndexes = (length, count) => {
                const indexes = [];
                while (indexes.length < count) {
                    const randomIndex = Math.floor(Math.random() * length);
                    if (!indexes.includes(randomIndex)) {
                        indexes.push(randomIndex);
                    }
                }
                return indexes;
            };

            const randomIndexes = getRandomIndexes(allPresetImageList.length, 3);

            const curPresetImageList = randomIndexes.map(index => {
                const modelInfo = FJTextToImageDataConfig.MODELS.find(
                    item => item.value === allPresetImageList[index].model_type,
                );
                return {
                    imageUrl: `${FJTextToImageConfig.presetImagePreviewPath}${allPresetImageList[index].imageUrl}`,
                    model_type: allPresetImageList[index].model_type,
                    style: allPresetImageList[index].style,
                    prompt: allPresetImageList[index].prompt,
                    smallImageUrl: allPresetImageList[index].originalUrl
                        ? `${FJTextToImageConfig.presetImagePreviewPath}${allPresetImageList[index].originalUrl}`
                        : null,
                    icon: modelInfo?.renderIcon,
                    name: modelInfo?.name,
                };
            });

            dispatch(setSlicePresetImageList(curPresetImageList));
        };
    },

    /**
     * 使用图片作为提示
     * @param {File | Blob} file
     * @returns
     */
    useImageAsPromptAction: function (file) {
        return async (dispatch, getState) => {
            const promptStatus = getState().textToImage.promptStatus;

            if (promptStatus !== FJTextToImageConstant.NORMAL) {
                return;
            }
            FJUtil.eaLog('ai tools text to image get prompts from image');

            _imageRecognitionStatus = true;
            dispatch(setSlicePromptStatus(FJTextToImageConstant.IMAGE_IMPORTING));
            dispatch(FJActionModal.hideUploadImageAsPromptModalAction());

            // 取消图片识别 | 中断生成 执行副作用
            const __cancelImageRecognitionCallback = () => {
                dispatch(setSlicePromptStatus(FJTextToImageConstant.NORMAL));
                dispatch(setSliceCurGeneratingPromptImageUrl(''));
            };

            const mimes = [
                'image/xbm',
                'image/tif',
                'image/apng',
                'image/jpg',
                'image/jpeg',
                'image/ico',
                'image/jfif',
                'image/webp',
                'image/png',
                'image/bmp',
                'application/octet-stream',
            ];
            const extensions = ['xbm', 'tif', 'apng', 'jpg', 'jpeg', 'ico', 'jfif', 'webp', 'png', 'bmp'];

            // 检查文件类型和后缀名
            const isValidType = file.type && mimes.includes(file.type);
            const extension = file.name ? file.name.split('.').pop().toLowerCase() : '';
            const isValidExtension = extension !== '' && extensions.includes(extension);

            if (!isValidType && !isValidExtension) {
                FJMessageStore.addMessage(FJLocalStore._('image-get-prompt-unsupported'), 'error');
                __cancelImageRecognitionCallback();
                return;
            }

            const imageData = await FJCompressedImageStore.compressImageByFile(file, { maxPixel: 400 });

            if (!_imageRecognitionStatus) {
                __cancelImageRecognitionCallback();
                return;
            }

            if (!imageData) {
                FJMessageStore.addMessage(FJLocalStore._('image-get-prompt-unsupported'), 'error');
                __cancelImageRecognitionCallback();
                return;
            }
            dispatch(setSliceCurGeneratingPromptImageUrl(imageData.src));

            const userSpaceType = await FJUtil.checkUserSpace({
                errorCallback: () => {
                    FJMessageStore.addMessage(FJLocalStore._('image-get-prompt-word-failed'), 'error');
                },
            });
            if (userSpaceType > 0) {
                dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                __cancelImageRecognitionCallback();
                return;
            }

            // 2. 上传图片
            const result = await FJImageStore.upLoadFileToS3ByUrl(imageData.src, { isCompress: false });

            if (!_imageRecognitionStatus || !result) {
                __cancelImageRecognitionCallback();
                return;
            }

            // 3. 生成图片描述
            const currentLang = FJLocalStore.currentTag();
            const { data, code } = await FJNetworkStore.generateImageByPrompt(result, currentLang);
            if (!_imageRecognitionStatus) {
                // 操作被用户取消
                return;
            }
            if (code === 200) {
                _imageRecognitionStatus = false;
                const prompt = data.prompt;
                dispatch(this.changePromptAction(prompt));
            } else {
                FJMessageStore.addMessage(FJLocalStore._('image-get-prompt-word-failed'), 'error');
            }
            dispatch(setSlicePromptStatus(FJTextToImageConstant.NORMAL));
        };
    },
    uploadImageUrlListAction: function (resources) {
        return async (dispatch, getState) => {
            const curModel = getState().textToImage.curModel;
            const originalImages = getState().textToImage.uploadImages.filter(item => !!item);
            let imageInfos = [];
            if (resources.length + originalImages.length > _getTextToImageMaxImages(curModel)) {
                FJMessageStore.addMessage(
                    FJLocalStore._('maximum-limit-for-uploaded-reference-images-reached'),
                    'error',
                );
            }

            imageInfos = await Promise.all(
                resources.map(async item => {
                    const { size, resource: url, name, id } = item;
                    if (size && (size.width > MAX_COMPRESS_IMAGE_SIZE || size.height > MAX_COMPRESS_IMAGE_SIZE)) {
                        const imageInfo = await FJCompressedImageStore.compressImageByUrl(url, {
                            name: name,
                        }).catch(() => {
                            throw new Error('compress image failed');
                        });
                        return imageInfo;
                    } else {
                        return {
                            name: name,
                            src: url,
                            width: size.width,
                            height: size.height,
                            id: id,
                        };
                    }
                }),
            );
            dispatch(
                setSliceUploadImages(
                    [
                        ...originalImages,
                        ...imageInfos.map(imageInfo => ({ ...imageInfo, type: 'local', source: FJConstant.LOCAL })),
                    ].slice(0, _getTextToImageMaxImages(curModel)),
                ),
            );
        };
    },
    uploadImageUrlAction: function (url, options = {}) {
        return async (dispatch, getState) => {
            const { isPrompt } = getState().textToImage;
            const curModel = getState().textToImage.curModel;

            const curModelData = FJTextToImageDataConfig.MODELS.find(item => item.value === curModel);
            const __urlToBlob = async url => {
                try {
                    const response = await fetch(url);
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    const blob = await response.blob();
                    const { name } = options;
                    name && (blob.name = name);
                    return blob;
                } catch (error) {
                    console.error('Error fetching the URL:', error);
                }
            };
            __urlToBlob(url)
                .then(blob => {
                    if (isPrompt) {
                        dispatch(this.useImageAsPromptAction(blob));
                    } else {
                        if (
                            curModelData &&
                            curModelData.supportImageReference &&
                            curModelData?.supportImageReferenceNum > 1
                        ) {
                            dispatch(this.uploadMultipleImagesAction([blob], options));
                        } else {
                            dispatch(this.uploadImageAction(blob));
                        }
                    }
                })
                .finally(() => {
                    dispatch(setSliceIsPrompt(false));
                });
        };
    },

    /**
     * @desc AI提示词优化
     * @returns
     */
    aiOptimizingAction: function () {
        return async (dispatch, getState) => {
            const promptStatus = getState().textToImage.promptStatus;

            if (promptStatus !== FJTextToImageConstant.NORMAL) {
                return;
            }

            const prompt = getState().textToImage.prompt;
            FJUtil.eaLog('ai tools text to image ai prompts click', { prompt });

            const _prompt = prompt.replace(/\s/g, '');
            if (_prompt.length === 0 || prompt.length === 0) {
                FJMessageStore.addMessage(FJLocalStore._('please-enter-the-prompt'), 'error');
                return;
            }

            const userSpaceType = await FJUtil.checkUserSpace({
                errorCallback: () => {
                    FJMessageStore.addMessage(FJLocalStore._('ai-optimization-prompts-failed'), 'error');
                },
            });
            if (userSpaceType > 0) {
                dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                return false;
            }

            _aiOptimizingStatus = true;
            dispatch(setSlicePromptStatus(FJTextToImageConstant.AI_OPTIMIZING));

            const { data, code } = await FJNetworkStore.aiOptimizing(prompt);

            if (!_aiOptimizingStatus) {
                return;
            }

            if (code === 200) {
                const prompt = data.prompt;
                const cleanedPrompt = prompt.replace(/^“|”$/g, '');
                dispatch(this.changePromptAction(cleanedPrompt.replace(/^"|"$/g, '')));
            } else {
                FJMessageStore.addMessage(FJLocalStore._('ai-optimization-prompts-failed'), 'error');
            }

            dispatch(setSlicePromptStatus(FJTextToImageConstant.NORMAL));
        };
    },

    /**
     * 取消图片识别
     * @returns
     */
    cancelImageRecognitionAction: function () {
        return async dispatch => {
            _imageRecognitionStatus = false;
            dispatch(setSlicePromptStatus(FJTextToImageConstant.NORMAL));
            dispatch(setSliceCurGeneratingPromptImageUrl(''));
        };
    },

    /**
     * 取消AI优化
     * @returns
     */
    cancelAiOptimizingAction: function () {
        return async dispatch => {
            _aiOptimizingStatus = false;
            dispatch(setSlicePromptStatus(FJTextToImageConstant.NORMAL));
        };
    },

    /**
     * 设置模型（统一方法，包含副作用）
     * @param {string} model
     * @returns
     */
    setModelAction: function (model) {
        return dispatch => {
            dispatch(setSliceModel(model));
            FJUserSelectionStore.save(FJAppConstant.TEXT_TO_IMAGE, SELECTION_KEYS.CUR_MODEL, model);
        };
    },

    /**
     * 修改模型
     * @param {string} model
     * @returns
     */
    changeModelAction: function (model, isInit = false) {
        return async (dispatch, getState) => {
            // REQUIREMENT: 不弹出弹窗, 切换模型，在生成处拦截
            const curModelData = FJTextToImageDataConfig.MODELS.find(item => item.value === model);
            dispatch(this.setModelAction(model));
            FJUtil.eaLog('ai_tools_text_to_image_model_select', { mode: curModelData?.name });

            // 更新提示词字符限制
            const promptLimit = curModelData?.promptCharacterLimit || FJTextToImageDataConfig.PROMPT_TEXT_LIMIT;
            dispatch(setSlicePromptMaxLength(promptLimit));

            // 如果新模型支持当前比例则继承，否则默认选择第一个
            const curRatio = getState().textToImage.curRatio;
            if (curModelData?.supportRatios?.includes(curRatio) && !isInit) {
                dispatch(setSliceRatio(curRatio));
            } else {
                dispatch(setSliceRatio(curModelData?.supportRatios?.[0]));
            }

            // 如果新模型支持当前分辨率则继承，否则默认选择第一个
            const curResolution = getState().textToImage.curResolution;
            if (curModelData?.supportResolutions?.find(item => item.value === curResolution) && !isInit) {
                dispatch(setSliceResolution(curResolution));
            } else {
                dispatch(setSliceResolution(curModelData?.supportResolutions?.[0]?.value || null));
            }
        };
    },

    /**
     * 上传图片
     * @param {File} file
     * @returns
     */
    uploadImageAction: function (file, skipTranscode = false) {
        return async (dispatch, getState) => {
            const uploadStatus = getState().textToImage.uploadStatus;
            if (uploadStatus === 'loading') {
                return;
            }

            const __fileError = () => {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
                dispatch(setSliceUploadStatus(FJConstant.DEFAULT));
            };

            const isImage = FJUtil.isImage(file, false, UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE);
            dispatch(setSliceUploadStatus(FJConstant.UPLOADING));

            if (!isImage) {
                if (skipTranscode) {
                    __fileError();
                    return;
                }
                // 使用转码功能
                try {
                    const result = await dispatch(
                        FJActionModal.showCloudTranscodingModalAction({
                            files: [file],
                            mediaType: 'image',
                            outputFormat: 'png',
                            onReupload: newFiles => {
                                if (newFiles && newFiles.length > 0) {
                                    // 重新上传文件
                                    dispatch(this.uploadImageAction(newFiles[0]));
                                }
                            },
                        }),
                    );
                    // 直接使用转码后的文件
                    file = result.files[0];
                } catch (e) {
                    if (e.cause === FJConstant.INVALID) {
                        __fileError();
                    }
                    dispatch(setSliceUploadStatus(FJConstant.DEFAULT));
                    return;
                }
            }

            try {
                const imageInfo = await FJCompressedImageStore.compressImageByFile(file);
                if (imageInfo) {
                    FJUtil.eaLog('text_to_image_upload', {
                        formats: file.type,
                    });
                    dispatch(setSliceUploadStatus(FJConstant.SUCCESS));
                    dispatch(setSliceUploadImageInfo({ ...imageInfo, type: 'local', source: FJConstant.LOCAL }));
                    dispatch(
                        setSliceUploadImages([
                            ...getState().textToImage.uploadImages,
                            { ...imageInfo, type: 'local', source: FJConstant.LOCAL },
                        ]),
                    );
                } else {
                    __fileError();
                }
            } catch (error) {
                __fileError();
            }
        };
    },

    /**
     * 清除上传的图片
     * @returns
     */
    clearUploadImageAction: function () {
        return dispatch => {
            dispatch(setSliceUploadImageInfo({}));
            dispatch(setSliceUploadStatus(FJConstant.DEFAULT));
        };
    },

    /**
     * 重试任务
     * @param {*} id
     * @returns
     */
    retryTaskAction: function (id) {
        return async (dispatch, getState) => {
            const { creationList } = getState().textToImage;
            const task = creationList.find(item => item.id === id);
            if (!task) {
                return;
            }
            const { prompt, model_type, ratio, generateNumber, style, inputImage, uploadImages, resolution } =
                task.generateInfo;
            const styleData = getState().textToImage.styleList.find(item => item.name === style);
            styleData
                ? dispatch(setSliceStyle(styleData))
                : dispatch(
                      setSliceStyle({
                          value: '',
                          name: 'none',
                          previewImg: 'none.jpg',
                      }),
                  );
            dispatch(setSlicePrompt(prompt));
            dispatch(this.setModelAction(model_type));
            dispatch(setSliceRatio(ratio));
            dispatch(setSliceGenerateNumber(generateNumber));
            inputImage && inputImage.src && dispatch(setSliceUploadImageInfo(inputImage));
            uploadImages && dispatch(setSliceUploadImages(uploadImages));
            resolution && dispatch(setSliceResolution(resolution));

            dispatch(this.generateAction());
        };
    },
    // 多图模式上传
    uploadMultipleImagesAction: function (files, skipTranscoded = false) {
        return async (dispatch, getState) => {
            const uploadStatus = getState().textToImage.uploadStatus;
            const originalImages = getState().textToImage.uploadImages.filter(item => !!item);
            const curModel = getState().textToImage.curModel;
            if (files.length + originalImages.length > _getTextToImageMaxImages(curModel)) {
                FJMessageStore.addMessage(
                    FJLocalStore._('maximum-limit-for-uploaded-reference-images-reached'),
                    'error',
                );
            }

            if (uploadStatus === FJConstant.LOADING) {
                return;
            }

            const __fileError = () => {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
                dispatch(setSliceUploadStatus(FJConstant.DEFAULT));
            };

            try {
                const filesArray = Array.from(files).slice(
                    0,
                    _getTextToImageMaxImages(curModel) - originalImages.length,
                );
                if (filesArray.length === 0) {
                    dispatch(setSliceUploadStatus(FJConstant.DEFAULT));
                    return;
                }

                const validFiles = filesArray.filter(file =>
                    FJUtil.isImage(file, false, UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE),
                );
                const transcodedFiles = filesArray.filter(
                    file => !FJUtil.isImage(file, false, UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE),
                );

                const _uploadImages = imageInfos => {
                    if (imageInfos.length > 0) {
                        dispatch(setSliceUploadStatus(FJConstant.SUCCESS));
                        let newImages = [...originalImages, ...imageInfos];
                        dispatch(setSliceUploadImages(newImages.slice(0, _getTextToImageMaxImages(curModel))));
                    } else {
                        __fileError();
                    }
                };

                // 统一处理文件的函数
                const processFiles = async filesToProcess => {
                    dispatch(setSliceUploadStatus(FJConstant.LOADING));
                    const imagePromises = filesToProcess.map(async file => {
                        const imageInfo = await FJCompressedImageStore.compressImageByFile(file);
                        return imageInfo ? { ...imageInfo, type: 'local', source: FJConstant.LOCAL } : null;
                    });
                    const imageResults = await Promise.all(imagePromises);
                    return imageResults.filter(img => img !== null);
                };

                // 收集所有要处理的文件
                let filesToProcess = [...validFiles];

                if (transcodedFiles.length > 0) {
                    if (skipTranscoded) {
                        FJMessageStore.addMessage(
                            FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                            'error',
                        );
                        // 只处理合法文件
                        const validImages = await processFiles(filesToProcess);
                        _uploadImages(validImages);
                        return;
                    }

                    // 使用转码功能
                    try {
                        const result = await dispatch(
                            FJActionModal.showCloudTranscodingModalAction({
                                files: transcodedFiles,
                                mediaType: 'image',
                                outputFormat: 'png',
                                inputOptions: {
                                    multiple: true,
                                },
                                onReupload: newFiles => {
                                    if (newFiles && newFiles.length > 0) {
                                        // 重新上传文件
                                        dispatch(this.uploadMultipleImagesAction(newFiles));
                                    }
                                },
                            }),
                        );

                        // 转码成功后，添加转码文件到处理列表
                        filesToProcess = [...filesToProcess, ...result.files];
                    } catch (e) {
                        if (e.cause === FJConstant.INVALID) {
                            __fileError();
                        }
                        dispatch(setSliceUploadStatus(FJConstant.DEFAULT));
                    }
                }

                // 统一处理所有文件
                if (filesToProcess.length > 0) {
                    const allValidImages = await processFiles(filesToProcess);
                    _uploadImages(allValidImages);
                }
            } catch (error) {
                __fileError();
            }
        };
    },

    /**
     * @description 跳转图生视频
     * @returns {(function(*): void)|*}
     */
    imageToVideoAction: function () {
        return (dispatch, getState) => {
            const tool = FJUtil.getToolName();
            FJUtil.eaLog('ai_image_tool_to_video_generator_click', { tool });

            const creationList = getState().textToImage.creationList;
            const avator = creationList[0]?.imgUrl || '';
            if (!avator) return;
            const recId = `${Date.now()}${Math.random().toString(36).substr(2, 9)}`;
            localStorage.setItem(recId, JSON.stringify({ avator }));
            const toolName = FJUtil.getAIToolHref(AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO);
            const url = FJUtil.getCurrentUrl() + toolName.slice(1) + '?rec_id=' + recId;

            window.open(url, '_blank');
        };
    },
};

export default FJActionTextToImage;
